import { render, staticRenderFns } from "./AccountStarOutline.vue?vue&type=template&id=1e6e44b2"
import script from "./AccountStarOutline.vue?vue&type=script&lang=js"
export * from "./AccountStarOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports